var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStreetViewIcon = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 20,
  viewBox: "0 0 12 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Street view icon"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.95987 7.0155C7.96582 7.0155 9.59197 5.44503 9.59197 3.50775C9.59197 1.57047 7.96582 0 5.95987 0C3.95391 0 2.32776 1.57047 2.32776 3.50775C2.32776 5.44503 3.95391 7.0155 5.95987 7.0155Z",
  fill: "#FCBE2C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.99794 7.65962C2.06796 7.43456 2.2999 7.27934 2.56247 7.2871L3.83278 7.28682C4.22664 7.29458 4.47928 7.67514 4.33486 8.00109L1.44653 14.5628C1.33712 14.8112 1.02641 14.9431 0.741948 14.8577L0.391847 14.7569C0.103014 14.6754 -0.0589076 14.4037 0.0198651 14.1476L1.99794 7.65962Z",
  fill: "#FCBE2C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.0044 7.65962C9.93435 7.43456 9.70218 7.27934 9.43934 7.2871H8.18729C7.79303 7.29486 7.52062 7.67514 7.66518 8.00109L10.552 14.5628C10.6615 14.8112 10.9726 14.9431 11.2573 14.8577L11.6078 14.7569C11.8969 14.6754 12.059 14.4037 11.9801 14.1476L10.0044 7.65962Z",
  fill: "#FCBE2C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.7834 7.28682H3.41137L3.05253 10.8953L2.64883 11.7829L2.7834 7.28682Z",
  fill: "#F1A42C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.2166 7.28682H8.58863L8.94747 10.8953L9.35117 11.7829L9.2166 7.28682Z",
  fill: "#F1A42C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.92977 7.28682L3.14253 19.6951C3.14543 19.8643 3.28831 20 3.46356 20H5.17034C5.22326 20 5.26665 19.9503 5.26665 19.8992L5.57184 14.9961C5.58056 14.8217 5.74623 14.686 5.93807 14.686C6.1299 14.686 6.29557 14.8217 6.30429 14.9961L6.60948 19.8992C6.60948 19.9509 6.65225 20 6.70575 20H8.45618C8.63143 20 8.7743 19.8643 8.7772 19.6951L8.98997 7.28682H2.92977Z",
  fill: "#FCBE2C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.28208 10.5454C6.12553 10.7923 5.75407 10.7923 5.59752 10.5454L3.90579 7.8768C3.74206 7.61854 3.93451 7.28682 4.24807 7.28682H7.63153C7.94509 7.28682 8.13754 7.61854 7.97381 7.8768L6.28208 10.5454Z",
  fill: "#E58A2D"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgStreetViewIcon);
export { ForwardRef as ReactComponent };